export enum userTypes {
  GROUP = 'group',
  PROFILE = 'profile',
  GROUP_HOME = 'groupHome',
}
